import { OwnerEntityType } from "../../enums/owner-entity-type-enum";
import { TimeLineType } from "../../enums/timeline-type-enum";
import { BaseModel } from "../base.model";
import { ClientBaseModel } from "../members/client/client-base-model";
import { UserBaseModel } from "../members/user/user-base.model";

export class TimelineModel extends BaseModel {
    backgroundJobId?: string;
    emailTemplateId?: string;
    type?: TimeLineType;
    tags: string[] = [];
    createdByUserName?: string;
    name?: string;
    description?: string;
    icon?: string;
    ownerId?: string;
    ownerEntityType?: OwnerEntityType;
    owner?: UserBaseModel;
    timeSpent?: number;
    clientBase?: ClientBaseModel;
}
